import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/RelatedProducts.module.css';

const relatedProducts = [
  { name: '网站B镜像账户', price: '14.99', icon: 'fas fa-brain', id: 'website-b-mirror' },
  { name: '网站C镜像账户', price: '12.49', icon: 'fas fa-robot', id: 'website-c-mirror' },
  { name: '网站D镜像账户', price: '19.99', icon: 'fas fa-laptop-code', id: 'website-d-mirror' },
  { name: '网站E成品号', price: '24.99', icon: 'fas fa-database', id: 'website-e-finished' },
];

const RelatedProducts = () => {
  return (
    <section className={styles.relatedProducts}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>相关推荐</h2>
        <div className={styles.productGrid}>
          {relatedProducts.map(product => (
            <div key={product.id} className={styles.productCard}>
              <div className={styles.imagePlaceholder}>
                <i className={product.icon}></i>
              </div>
              <h3>{product.name}</h3>
              <p>价格: ${product.price}</p>
              <Link to={`/product/${product.id}`} className={styles.btn}>查看详情</Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedProducts;